<div class="modal-header">
  <h5 class="modal-title text-center ml-auto mr-auto">{{ 'select_your_agents' | translate: lang }}</h5>
  <button
    (click)="verifySelectedChampions()"
    type="button"
    class="close"
    data-dismiss="modal"
    aria-label="Close"
  >
    <svg-selector [svgName]="'close-small'" [svgColor]="'#ffffff'"></svg-selector>
  </button>
</div>
<div class="modal-body">
  <div class="champion-selector">
    <div class="champion-select-header">
      <div class="form-group">
        <input
          (keyup)="filterChampions($event)"
          type="text"
          class="form-control champion-list-search"
          placeholder="{{ 'search' | translate: lang }}"
        >
      </div>
    </div>
    <div class="champion-list">
      <div
        class="champion-item"
        *ngFor="let champion of availableChampions"
        (click)="toggleChampionSelection(champion.name)"
        [class.active]="currentSelectedChampions.indexOf(champion.name) > -1"
      >
        <img [src]="'https://cdn.ggboost.com/images/valorant-champions/' + champion.name + '.png'">
      </div>
    </div>
  </div>

  <app-button size="form" [block]="true" (clicked)="verifySelectedChampions()">{{ 'confirm' | translate: lang }}</app-button>
</div>
